import axios from 'axios';
import { API_URL } from '../utils/config';
import { getToken } from './auth/authService';

// Configuración para incluir el token en todas las solicitudes
const getAuthHeader = async () => {
  const token = await getToken();
  return token ? { Authorization: `Token ${token}` } : {};
};

// Servicio para gestionar ubicaciones
const locationService = {
  // Obtener todas las ubicaciones
  getAllLocations: async () => {
    try {
      const headers = await getAuthHeader();
      const response = await axios.get(`${API_URL}/locations/`, {
        headers
      });
      return response.data;
    } catch (error) {
      console.error('Error al obtener ubicaciones:', error);
      throw error;
    }
  },

  // Obtener una ubicación por ID
  getLocationById: async (id) => {
    try {
      const headers = await getAuthHeader();
      
      // Obtener el usuario del localStorage
      const userStr = localStorage.getItem('user');
      const user = userStr ? JSON.parse(userStr) : null;
      
      // Si el usuario es piloto, usar el endpoint específico
      if (user && user.is_pilot === true) {
        console.log('Usuario es piloto, intentando obtener ubicaciones de misiones...');
        try {
          // Primero intentar obtener todas las ubicaciones de misiones del piloto
          const pilotLocationsResponse = await axios.get(`${API_URL}/locations/by-pilot-missions/`, { headers });
          console.log('Ubicaciones del piloto:', pilotLocationsResponse.data);
          
          // Buscar la ubicación específica en las ubicaciones del piloto
          const features = pilotLocationsResponse.data.features || [];
          const locationFeature = features.find(feature => feature.id === id || feature.properties.id === id);
          
          if (locationFeature) {
            console.log('Ubicación encontrada en las misiones del piloto:', locationFeature);
            return locationFeature;
          }
        } catch (pilotError) {
          console.error('Error al obtener ubicaciones del piloto:', pilotError);
          // Continuar con el enfoque normal si falla
        }
      }
      
      // Enfoque normal: intentar obtener la ubicación directamente
      const response = await axios.get(`${API_URL}/locations/${id}/`, {
        headers
      });
      return response.data;
    } catch (error) {
      console.error(`Error al obtener ubicación ${id}:`, error);
      throw error;
    }
  },
  
  // Obtener ubicaciones de las misiones del piloto
  getPilotMissionLocations: async () => {
    try {
      const headers = await getAuthHeader();
      const response = await axios.get(`${API_URL}/locations/by-pilot-missions/`, {
        headers
      });
      return response.data;
    } catch (error) {
      console.error('Error al obtener ubicaciones de misiones del piloto:', error);
      throw error;
    }
  }
};

export default locationService;